import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import LoginComponent from '../components/Login';

const Login = () => {
  const history = useHistory();
  const location = useLocation();
  const [afterLoginUrl, setAfterLoginUrl] = useState('/');

  useEffect(() => {
    setAfterLoginUrl(location?.state?.afterLoginUrl || '/');
  }, [location]);

  const onLineLoginClick = useCallback(() => {
    history.push('/auth/line/login', {
      afterLoginUrl,
      action: 'login',
    });
  }, [afterLoginUrl, history]);

  const onRegisterClick = useCallback(() => {
    history.push('/register', {
      afterLoginUrl,
    });
  }, [history, afterLoginUrl]);

  return (
    <LoginComponent
      onRegisterClick={onRegisterClick}
      onLineLoginClick={onLineLoginClick}
    />
  );
};

export default Login;
